import PropTypes from 'prop-types';

import React, { useContext } from 'react';

const AppShellContext = React.createContext();

function useAppShellContext() {
  return useContext(AppShellContext);
}

const AppShellContextProvider = ({ children, config }) => (
    <AppShellContext.Provider value={config}>
      {children}
    </AppShellContext.Provider>
  );

AppShellContextProvider.propTypes = {
  config: PropTypes.objectOf(
    PropTypes.shape({
      redirects: PropTypes.objectOf(PropTypes.string),
      modules: PropTypes.shape({
        url: PropTypes.string,
        modules: PropTypes.objectOf(PropTypes.func)
      }),
      config: PropTypes.shape({})
    })
  ).isRequired,
  children: PropTypes.node
};

export { AppShellContextProvider, useAppShellContext };
